export default function useLocale() {
    const locale = window.location.pathname.includes("/en/") ? "en" : "es";

    return locale;
}
